export default __webpack_public_path__ + "static/media/pt-serif-v12-latin-regular.2b243476.svg";